import Form from 'react-bootstrap/Form';
import { Button, Col, Row } from 'react-bootstrap';
import { useCallback, useMemo, useState } from 'react';
import {
  Collection,
  CollectionLevel,
  CollectionLevelItemInput,
  CollectionReward,
  GetBadgesQuery,
  GetItemsQuery,
  LevelRewardInput,
} from '../../../../../../__gqltypes__';
import CollectionLevelComponent from './CollectionLevel';
import Chip from '../../../components/Chip';
import EditRewardsModal from '../../../components/EditRewardsModal';

type Props = {
  index: number;
  level: CollectionLevel;
  collectionData: Collection;
  setLevels: React.Dispatch<CollectionLevel>;
  badgesData?: GetBadgesQuery;
  vanityData?: GetItemsQuery;
};

export default function UpgradeForm({ index, level, collectionData, setLevels, badgesData, vanityData }: Props) {
  const [isEditMode, setIsEditMode] = useState(false);
  const [showEditReward, setShowEditReward] = useState(false);
  const [selectedReward, setSelectedReward] = useState<LevelRewardInput | null>(null);
  const [rewardIndex, setRewardIndex] = useState(0);

  const rewards = useMemo(() => level?.rewards ?? [], [level]);

  console.log(`UpgradeForm re-render ${index}`);
  console.log(level);
  const onChangedItems = (lvl: CollectionLevelItemInput[]) => {
    const newLevel = { ...level };
    // @ts-ignore
    newLevel.items = lvl;
    setLevels(newLevel);
  };

  const onChangeReward = useCallback((reward_: CollectionReward[]) => {
    const newLevel = { ...level };
    console.log(level);
    newLevel.rewards = reward_;
    setLevels(newLevel);
  }, [level, setLevels]);

  const handleShowEditReward = useCallback(
    (idx: number, isEdit: boolean) => {
      setIsEditMode(isEdit);
      if (isEdit) {
        const rew = rewards[idx];
        const levelReward = {
          amount: rew.amount,
          type: rew.type,
          itemId: rew.itemId,
        };
        setSelectedReward(levelReward as LevelRewardInput);
      } else {
        setSelectedReward(null);
      }
      setRewardIndex(idx);
      setShowEditReward(true);
    },
    [rewards]
  );

  const handleRemoveReward = useCallback(
    (idx: number) => {
      if (idx >= 0 && idx < rewards.length) {
        let newRewards = [...rewards];
        newRewards = newRewards.filter((val, index_) => index_ !== idx);
        onChangeReward(newRewards);
      }
    },
    [onChangeReward, rewards]
  );

  const handleAddReward = useCallback(
    (newReward: LevelRewardInput) => {
      if (isEditMode) {
        const newRewards = [...rewards];
        newRewards[rewardIndex] = {
          type: newReward.type,
          amount: newReward.amount,
          itemId: newReward.itemId ?? '',
          __typename: 'CollectionReward',
        };
        onChangeReward(newRewards);
      } else {
        const newRewards = [...rewards];
        newRewards.push({
          type: newReward.type,
          amount: newReward.amount,
          itemId: newReward.itemId ?? '',
          __typename: 'CollectionReward',
        });
        onChangeReward(newRewards);
      }
      setShowEditReward(false);
    },
    [isEditMode, rewards, rewardIndex, onChangeReward]
  );
  return (
    <Form>
      <hr />
      <h5>
        Item level
        {index}
      </h5>
      <Row>
        <EditRewardsModal
          isEdit={isEditMode}
          tier={null}
          show={showEditReward}
          level={0}
          reward={selectedReward}
          handleSave={handleAddReward}
          handleClose={() => setShowEditReward(false)}
          disableCurrencySpecialEvent
          disableSubscriptionDay={false}
          disableMonthlyBuff
          enableItemLevelEdit
          enableExtendedFragmentSelector
        />
        <Col>
          <Button variant="success" className="mr-2" onClick={() => handleShowEditReward(rewards.length, false)}>
            <i className="fas fa-plus mr-2" />
            Add Reward
          </Button>
          <Row className="mb-3">
            <Col className="d-flex flex-column align-items-center">
              <Form.Label className="font-weight-bold">Rewards</Form.Label>
              {rewards.map((reward: CollectionReward, rIdx: number) => {
                return (
                  <Row key={rIdx} className="mt-2 align-items-end">
                    <Chip
                      reward={reward as LevelRewardInput}
                      canDelete
                      btnAction={() => handleRemoveReward(rIdx)}
                      globalAction={() => handleShowEditReward(rIdx, true)}
                    />
                  </Row>
                );
              })}
            </Col>
          </Row>
        </Col>
      </Row>
      <CollectionLevelComponent
        collectionType={collectionData.type}
        items={level?.items ?? []}
        onChangedItems={onChangedItems}
        badgesData={badgesData}
        vanityData={vanityData}
      />
    </Form>
  );
}
